import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export function getInitials(name: string): string {
	if (!name) return "U"
	const parts = name.trim().split(/\s+/)
	if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase()
	return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

export function formatCurrency(amount?: number | null): string {
	if (amount == null) return "—"
	return new Intl.NumberFormat("es-ES", {
		style: "currency",
		currency: "EUR",
		maximumFractionDigits: 0,
	}).format(amount)
}

export function formatDate(dateString?: string | null): string {
	if (!dateString) return "—"
	return new Intl.DateTimeFormat("es-ES", {
		day: "2-digit",
		month: "short",
		year: "numeric",
	}).format(new Date(dateString))
}

export function formatDateRelative(dateString?: string | null, locale?: string): string {
	if (!dateString) return "—"
	const date = new Date(dateString)
	const now = new Date()
	const diffMs = date.getTime() - now.getTime()
	const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24))

	const rtf = new Intl.RelativeTimeFormat(locale || "es-ES", { numeric: "auto" })
	return rtf.format(diffDays, "day")
}

export function getRelevanceColor(score?: number | null): string {
	if (score == null) return "text-muted-foreground"
	if (score >= 75) return "text-emerald-600"
	if (score >= 50) return "text-amber-600"
	return "text-red-500"
}

export function getRelevanceBgColor(score?: number | null): string {
	if (score == null) return "bg-gray-100 text-gray-500"
	if (score >= 75) return "bg-emerald-50 text-emerald-700 border-emerald-200"
	if (score >= 50) return "bg-amber-50 text-amber-700 border-amber-200"
	return "bg-red-50 text-red-700 border-red-200"
}
